import React, { useEffect, useState } from "react"
import { useHtmlClassService } from "../../../../../_metronic/layout/index.js"
import { Stepper } from "../../../../../component/atoms/Stepper/index.jsx"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { MenuBack } from "../../../../../component/atoms/MenuBack/index.jsx"
import { SelectArea } from "./StepForm/SelectArea.jsx"
import { FormulirSertification } from "./StepForm/FormulirSertification.jsx"
import { useFormik } from "formik"
import * as yup from "yup"
import { FORM_NEED, getStringErrorMassage } from "../../../../helpers/StringCollection.js"
import { Review } from "./StepForm/Review.jsx"
import {
  createCertification,
  initCreateCertification,
  getListSeedClass,
  getVarietyFilterCertification
} from "../../../../../redux/actions/SubmissionAction.jsx"
import { useDispatch, useSelector } from "react-redux"
import { PopupQuestion } from "../../../../../component/atoms/Popup/index.jsx"
import { Col } from "react-bootstrap"
import swal from "sweetalert"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { useHistory } from "react-router-dom"
import { SUBMISSION } from "../../../../../constants/InitTypeConstants.js"
import { getCertificationPlanType } from "../../../../../redux/actions/MasterDataAction.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { DATE_TYPE_ENUM } from "../../../../../constants/StringConstant.js"
import { convertDigits } from "../../../../helpers/TextHelper.js"

export const CreateSubmissionPage = () => {
  const uiService = useHtmlClassService()
  const dispatch = useDispatch()
  const { Submission, General, MasterData } = useSelector((state) => state)
  const history = useHistory()

  const labelStep = ["Pilih Lahan", "Isi Formulir Sertifikasi", "Review"]
  const [activeStep, setActiveStep] = useState(0)
  const [selectedArea, setSelectedArea] = useState([])
  const [dataInit, setDataInit] = useState(null)
  const [showPopupExit, setShowPopupExit] = useState(false)
  const [isFormInitialized, setIsFormInitialized] = useState(false)

  const resetForm = () => {
    setIsFormInitialized(false)
    formFormik.resetForm(initForm)
    setDataInit(null)
  }

  const initForm = {
    variety_id: "",
    male_planting_date: "",
    female_planting_date: "",
    female_seed_total: 0,
    female_lot_number: "",
    female_seri_label: "",
    female_label_images: [],
    male_seed_total: 0,
    male_lot_number: "",
    male_seri_label: "",
    male_label_images: [],
    location_image: "",
    plant_type_id: ""
  }

  const validationForm = yup.object({
    variety_id: yup
      .string()
      .nullable()
      .required(getStringErrorMassage("Varietas", FORM_NEED.harusDiIsi)),
    source_seed_class: yup
      .string()
      .nullable()
      .required(getStringErrorMassage("Asal Kelas Benih", FORM_NEED.harusDiIsi)),
    male_planting_date: yup
      .string()
      .nullable()
      .required(getStringErrorMassage("Tanggal Tanam Jantan", FORM_NEED.harusDiIsi)),
    female_planting_date: yup
      .string()
      .nullable()
      .required(getStringErrorMassage("Tanggal Tanam Betina", FORM_NEED.harusDiIsi)),
    female_lot_number: yup
      .string()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.female_base_name !== null
        },
        then: (schema) =>
          schema.required(getStringErrorMassage("Nomor Lot Betina", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    female_seri_label: yup
      .string()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.female_base_name !== null
        },
        then: (schema) =>
          schema.required(getStringErrorMassage("Nomor Seri Label Betina", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    female_label_images: yup
      .array()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.female_base_name !== null
        },
        then: (schema) =>
          schema.required(getStringErrorMassage("Foto Label Betina", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    female_seed_total: yup
      .number()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.female_base_name !== null
        },
        then: (schema) =>
          schema
            .positive("Harus lebih dari 0")
            .moreThan(0, "Harus lebih dari 0")
            .typeError("Harus angka")
            .required(getStringErrorMassage("Jumlah Benih ", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    male_lot_number: yup
      .string()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.male_base_name !== null
        },
        then: (schema) =>
          schema.required(getStringErrorMassage("Nomor Lot Jantan", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    male_seri_label: yup
      .string()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.male_base_name !== null
        },
        then: (schema) =>
          schema.required(getStringErrorMassage("Nomor Seri Label Jantan", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    male_label_images: yup
      .array()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.male_base_name !== null
        },
        then: (schema) =>
          schema.required(getStringErrorMassage("Foto Label Jantan", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    male_seed_total: yup
      .number()
      .nullable()
      .when("variety_id", {
        is: (varietyId) => {
          if (!varietyId || !dataInit) return false
          const variety = dataInit.variety_list?.find((v) => v.variety_id === varietyId)
          return variety?.male_base_name !== null
        },
        then: (schema) =>
          schema
            .positive("Harus lebih dari 0")
            .moreThan(0, "Harus lebih dari 0")
            .typeError("Harus angka")
            .required(getStringErrorMassage("Jumlah Benih ", FORM_NEED.harusDiIsi)),
        otherwise: (schema) => schema
      }),
    location_image: yup
      .string()
      .nullable()
      .required(getStringErrorMassage("Foto Lokasi", FORM_NEED.harusDiIsi))
  })

  const formFormik = useFormik({
    initialValues: initForm,
    validationSchema: validationForm,
    enableReinitialize: true,
    validateOnMount: false,
    validateOnChange: true,
    onSubmit: (values) => {
      const currentVariety = dataInit?.variety_list?.find((v) => v.variety_id === values.variety_id)
      const isFemaleEnabled = currentVariety?.female_base_name !== null
      const isMaleEnabled = currentVariety?.male_base_name !== null

      const body = {
        area_ids: selectedArea,
        variety_id: values.variety_id,
        source_seed_class: values.source_seed_class,
        male_planting_date: values.male_planting_date,
        female_planting_date: values.female_planting_date,

        // Only send female fields if enabled
        female_seed_total: isFemaleEnabled ? values.female_seed_total : null,
        female_lot_number: isFemaleEnabled ? values.female_lot_number : null,
        female_seri_label: isFemaleEnabled ? values.female_seri_label : null,
        female_label_images:
          isFemaleEnabled && values.female_label_images?.length > 0
            ? values.female_label_images
            : null,

        // Only send male fields if enabled
        male_seed_total: isMaleEnabled ? values.male_seed_total : null,
        male_lot_number: isMaleEnabled ? values.male_lot_number : null,
        male_seri_label: isMaleEnabled ? values.male_seri_label : null,
        male_label_images:
          isMaleEnabled && values.male_label_images?.length > 0 ? values.male_label_images : null,

        location_image: values.location_image,
        plant_type_id: values.plant_type_id
      }
      dispatch(createCertification(body))
    }
  })

  useEffect(() => {
    uiService.setFullPage()
  }, [])

  useEffect(() => {
    dispatch(getVarietyFilterCertification())
    dispatch(getListSeedClass())
    dispatch(getCertificationPlanType())
  }, [])

  useEffect(() => {
    if (activeStep === 0) {
      resetForm()
    }
  }, [activeStep])

  useEffect(() => {
    const body = {
      area_ids: selectedArea
    }

    if (selectedArea && selectedArea.length > 0 && activeStep === 1 && !isFormInitialized) {
      dispatch(initCreateCertification(body))
    }
  }, [selectedArea, activeStep, isFormInitialized])

  useEffect(() => {
    if (Submission.initCreateCertification && !dataInit) {
      setDataInit(Submission.initCreateCertification)
    }
  }, [Submission.initCreateCertification, dataInit])

  useEffect(() => {
    if (dataInit && !isFormInitialized) {
      const isFormEmpty =
        !formFormik.values.variety_id &&
        !formFormik.values.seed_class &&
        !formFormik.values.plant_type_id

      if (!isFormEmpty) {
        setIsFormInitialized(true)
        return
      }

      // Set initial form values from dataInit
      if (dataInit.variety_id) {
        formFormik.setFieldValue("variety_id", dataInit.variety_id)

        if (dataInit.variety_list) {
          const selectedVariety = dataInit.variety_list.find(
            (item) => item.variety_id === dataInit.variety_id
          )

          if (selectedVariety) {
            if (
              selectedVariety.female_base_name !== null &&
              selectedVariety.female_total_seed !== null
            ) {
              const calculatedFemaleSeed =
                Math.ceil((selectedVariety.female_total_seed * dataInit.total_land_area_ha) / 4) * 4
              formFormik.setFieldValue("female_seed_total", calculatedFemaleSeed)
            }

            if (
              selectedVariety.male_base_name !== null &&
              selectedVariety.male_total_seed !== null
            ) {
              const calculatedMaleSeed = convertDigits(
                selectedVariety.male_total_seed * dataInit.total_land_area_ha,
                0
              )
              formFormik.setFieldValue("male_seed_total", calculatedMaleSeed)
            }
          }
        }
      }

      if (dataInit.female_planting_start_date) {
        formFormik.setFieldValue(
          "female_planting_date",
          timeStampToDate(dataInit.female_planting_start_date, DATE_TYPE_ENUM.ISO_DATE_EURO)
        )
      }

      if (dataInit.male_planting_date) {
        formFormik.setFieldValue(
          "male_planting_date",
          timeStampToDate(dataInit.male_planting_date, DATE_TYPE_ENUM.ISO_DATE_EURO)
        )
      }

      if (dataInit.plant_type_id) {
        formFormik.setFieldValue("plant_type_id", dataInit.plant_type_id)
      }

      if (dataInit.seed_class) {
        formFormik.setFieldValue("seed_class", dataInit.seed_class)
      }

      if (dataInit.source_seed_class) {
        formFormik.setFieldValue("source_seed_class", dataInit.source_seed_class)
      }
    }
  }, [dataInit, isFormInitialized])

  useEffect(() => {
    if (
      General?.isFinishUpdateOrDelete &&
      General.actionInitType === SUBMISSION.CREATE_SUBMISSION
    ) {
      swal({
        text: Submission?.responseCreateSubmission?.message,
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_CREATE_SUBMISSION,
        buttons: {
          detail: {
            text: "Lihat Pengajuan",
            className: "sweet-outline-success"
          },
          okey: { text: "Ok", className: "sweet-success" }
        }
      }).then((value) => {
        resetForm()

        if (value === "detail") {
          history.push(
            RoutesConstants.SUBMISSION.DETAIL_BLOCK_CERTIFICATION(
              "submitted",
              Submission?.responseCreateSubmission?.id
            )
          )
        } else {
          history.push(RoutesConstants.SUBMISSION.LIST_SUBMISSION_BY_STATUS("pending"))
        }
      })
    }
  }, [General, MasterData])

  const header = (
    <div
      className={
        "bg-white d-flex justify-content-between align-items-center p-6 border-1 border-bottom border-bottom-light-dark"
      }>
      <MenuBack title={"Buat Pengajuan Sertifikasi"} onClick={() => setShowPopupExit(true)} />
      <Stepper step={labelStep} activeStep={activeStep} setActiveStep={setActiveStep} />
    </div>
  )

  const dataStepbody = [
    <SelectArea
      key={0}
      selectedArea={selectedArea}
      setSelectedArea={setSelectedArea}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
    />,
    <FormulirSertification
      key={1}
      dataInit={dataInit}
      formik={formFormik}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      isFormInitialized={isFormInitialized}
    />,
    <Review
      formik={formFormik}
      dataInit={dataInit}
      key={2}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
    />
  ]

  const getBodyStep = (step) => {
    return dataStepbody[step]
  }

  const modalConfirmationExit = (
    <PopupQuestion
      title={"KELUAR DARI PEMBUATAN SERTIFIKASI"}
      onCancel={() => setShowPopupExit(false)}
      centered={true}
      variantOkButton={"danger"}
      textOk={"Oke"}
      textCancel={"Kembali"}
      onOk={() => {
        resetForm()
        history.push(RoutesConstants.SUBMISSION.LIST_SUBMISSION_BY_STATUS("pending"))
      }}
      show={showPopupExit}
      bodyCustom={
        <Col>
          <p className={"text-center"}>
            Apakah Anda yakin ingin keluar dari pembuatan sertifikasi? Perubahan yang belum disimpan
            akan hilang.
          </p>
        </Col>
      }
    />
  )

  // handle back browser
  useEffect(() => {
    // hanadle back browser
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener("popstate", function () {
      window.history.pushState(null, document.title, window.location.href)
      setShowPopupExit(true)
    })

    //   handle refresh page
    const handleBeforeUnload = (event) => {
      event.preventDefault()
    }
    window.addEventListener("beforeunload", handleBeforeUnload)
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  })

  return (
    <div>
      {modalConfirmationExit}
      {header}
      {getBodyStep(activeStep)}
    </div>
  )
}
